<template>
  <div class="example">
    <apexcharts height="250" type="area" :options="chartOptions" :series="series"></apexcharts>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
export default {
  components: {
    apexcharts: VueApexCharts,
  },
  props: {
    data: { required: true, type: Array },
  },
  data() {
    return {
      selection: "one_year",
    };
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          id: "area-datetime",
          type: "area",
          height: 350,
          zoom: {
            autoScaleYaxis: true,
          },
          toolbar: {
            show: false,
          },
        },

        colors: ["#FFDE36"],
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        xaxis: {
          categories: this.categoriesLabel,
        },

        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return parseInt(val);
            },
          },
        },
        legend: {
          show: false,
        },
      };
    },
    categoriesLabel() {
      return this.data?.map((value) => (value.date ? value.date : value.hour + ":00hrs"));
    },
    series() {
      return [
        {
          name: "Nuevos Tickets",
          data: this.data.map((summary) => summary?.count),
        },
      ];
    },
  },
};
</script>
